import Types from './types';

const initialState = {
  refreshData: false,
  user: {
    name: '',
    family: '',
    profile_image: '',
    phone: '',
    profile: {},
    store: {},
  },
  isLoggedIn: false,
  user_type: 'user',
  isMenuOpen: false,
  cart_count: 0,
};

export default function reducer(state = initialState, { type, data }) {
  switch (type) {
    case Types.SaveData:
      return { ...state, ...data };

    default:
      return state;
  }
}
